import { render } from "./OrdersCanceled.vue?vue&type=template&id=5486fe8e"
import script from "./OrdersCanceled.vue?vue&type=script&lang=ts"
export * from "./OrdersCanceled.vue?vue&type=script&lang=ts"
script.render = render

export default script